/**
 * 객체에서 null, undefined, 빈 문자열("") 값을 가진 key를 제거
 * - 검색/필터 파라미터를 서버에 보내기 직전 정제할 때 사용
 *
 * @param {object} obj - 원본 파라미터 객체
 * @returns {object} - 불필요한 값을 제거한 새 객체
 */
export function cleanParams(obj = {}) {
  const result = {};

  Object.entries(obj).forEach(([key, value]) => {
    const isEmpty =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '전체' ||
      (Array.isArray(value) && value.length === 0);

    if (!isEmpty) {
      result[key] = value;
    }
  });

  return result;
}
